module.exports = __webpack_public_path__ + "static/img/loading.2847961.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 1